import { Skeleton } from "@mui/material";
import classNames from "classnames";
import styles from "./style.module.scss";

function RangeCaptionSkeleton({ className }: { className?: string }) {
  return (
    <div className={classNames(styles.caption, className)}>
      <Skeleton variant="circular" width={16} height={16} />
      <Skeleton variant="text" width={190} height={18} />
      <Skeleton variant="text" width={168} height={18} />
    </div>
  );
}

export default RangeCaptionSkeleton;
